import { ReactNode } from "react"
import { Link as WouterLink } from "wouter"
import { Box } from "@mui/material"

const Link = ({children, noDecoration,  onClick, sx, to}: {children: ReactNode, noDecoration?: boolean, onClick?: () => void, sx?: object, to: string}) => {
  const currentLocation = window.location.pathname

  if (noDecoration) {
    return (
      <WouterLink onClick={onClick} to={to} state={{prevUrl: currentLocation}} style={{
        color: "inherit",
        textDecoration: "none",
        ...sx
      }}>
        {children}
      </WouterLink>
    )
  }

  return (
    <WouterLink onClick={onClick} style={{color: "inherit", textDecoration: "none"}} to={to} state={{prevUrl: currentLocation}}>
      <Box sx={{
        ":hover": {
           color: "primary.dark",
           cursor: "pointer",
           textDecorationLine: "underline"
        },
        ...sx
      }}>
        {children}
      </Box>
    </WouterLink>
  )
}

export default Link
